module.exports = __webpack_public_path__ + "media/bootstrap-icons/person-fill-1708317b.svg";